<script setup lang="ts">
import { inject, provide } from 'vue';
import { LIST_PANE_HOST, RECORD_PANE_NAVIGATOR } from '@/composables/recordPaneTrail';

/**
 * Wraps one table cell or one card of a list, so a related record's link in
 * it shows in the list's pane. The link's row is selected, and the pane moves
 * on from that row to the related record.
 *
 * Without a list pane around it, as on the search page, it provides nothing,
 * and the link opens the side peek as before. It draws nothing of its own.
 */
const props = defineProps<{
    rowId: string;
}>();

const host = inject(LIST_PANE_HOST, null);
if (host) {
    provide(RECORD_PANE_NAVIGATOR, {
        isActive: () => host.isActive(),
        showRecord: (entityId, recordId, options) => host.showFromRow(props.rowId, entityId, recordId, options),
    });
}
</script>

<template>
  <slot />
</template>
